import RoomOutlinedIcon from "@mui/icons-material/RoomOutlined"
import { Box, Typography } from "@mui/material"
import React from "react"
import { customPalette } from "../../theme"
import { Address } from "../core/dto/address"

interface IProps {
  address?: Address
}

export function AddressDisplayer({ address }: Readonly<IProps>): React.JSX.Element {
  return (
    <Box display="flex" alignItems="center" flexDirection="row" gap={1} sx={{ color: customPalette.subtitleGray }}>
      <RoomOutlinedIcon />
      {address?.street && <Typography variant="body2">{`${address?.street} · `}</Typography>}
      {address?.additional && <Typography variant="body2">{`${address?.additional} · `}</Typography>}
      <Typography variant="body2">{`${address?.city}`}</Typography>
    </Box>
  )
}
